import { TASK_COUNT_QUERY } from '../GraphQL/queries'
import { TaskCountQuery } from '../Types'
import { useQuery } from '@apollo/client'
import { useHostTasksClient } from './useHostTasksClient'
import { hostHome } from '../BusinessLogic/useTopNav'
import { Link } from '../BusinessLogic/index'
import { useEffect } from 'react'
import { UserResponseDto } from '@headbox-ui/auth-hook/dist/useGlobalAuth'
import { ActorRoles } from '../BusinessLogic/useActorRoleContext'
import * as Sentry from '@sentry/browser'

const canSeeNotifications: ActorRoles[] = [ActorRoles.LEAD_FEED_HOST, ActorRoles.SMART_BOOK_HOST]

export const affixNotifications = (role: ActorRoles, navOptionsByRole: Link[], notificationCount: number): Link[] => {
  if (canSeeNotifications.includes(role) && notificationCount !== undefined && notificationCount > 0) {
    const index = navOptionsByRole.indexOf(hostHome)
    navOptionsByRole[index] = {
      ...navOptionsByRole[index],
      notificationCount
    }
  }

  return navOptionsByRole
}

export const useNotifications = (user: UserResponseDto, role: ActorRoles): number | undefined => {
  const client = useHostTasksClient()

  const { data, error, loading } = useQuery<TaskCountQuery>(TASK_COUNT_QUERY, {
    skip: user?.id === undefined || role === undefined,
    client,
    variables: {
      userId: user?.id
    }
  })

  useEffect(() => {
    if (error != null) {
      Sentry.captureException(error)
    }
  }, [error])

  if (!loading && data?.taskCount >= 0) return data.taskCount
}
